import React from 'react'

export default props => (
	<section 
		style={{
			display: 'flex',
			height: 'auto',
			minHeight: '100%',
			backgroundSize: 'cover',
			background: `linear-gradient(to bottom, ${props.gradientStart}, ${props.gradientEnd})` 
		}}>
		<div
			style={{
				display: 'flex',
				flexDirection: 'column', 
				height: 'auto',
				minHeight: '100%',
				width: '100%',
				backgroundImage: `url(${props.imagem})`,
				backgroundSize: 'cover',
				backgroundRepeat: 'no-repeat',
				backgroundPosition: props.backgroundPosition || 'center'
			}}>
			{props.children}
		</div>
	</section>
)
